// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import phone01Icon from "@/assets/icons/phone-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Phone01IconProps = Omit<IconProps, "name">;

export function Phone01Icon(props: Phone01IconProps): React.ReactNode {
  return <Icon name={phone01Icon} {...props} />;
}
